import { useAppStore } from '@/store/AppStore';

export default function TeamStatus() {
  const { teams } = useAppStore();

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-white">
      <div className="flex items-center justify-between border-b border-background-100 px-5 py-4">
        <h2 className="font-heading text-[15px] font-bold text-foreground-950">Ekip Durumu</h2>
        <span className="text-xs font-semibold text-foreground-400">{teams.length} ekip</span>
      </div>

      <ul className="divide-y divide-background-100">
        {teams.map((team) => {
          const available = team.status === 'Müsait';
          return (
            <li key={team.id} className="flex items-center gap-4 px-5 py-4">
              <div
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${
                  available ? 'bg-emerald-50 text-emerald-600' : 'bg-primary-50 text-primary-600'
                }`}
              >
                <i className="ri-group-fill text-lg" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-bold text-foreground-900">{team.name}</div>
                <div className="truncate text-xs text-foreground-500">{team.members.join(' · ')}</div>
              </div>
              <div className="text-right">
                <div
                  className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${
                    available ? 'bg-emerald-50 text-emerald-700' : 'bg-accent-100 text-accent-800'
                  }`}
                >
                  <span className={`h-1.5 w-1.5 rounded-full ${available ? 'bg-emerald-500' : 'bg-accent-500'}`} />
                  {team.status}
                </div>
                {team.location && (
                  <div className="mt-1 flex items-center justify-end gap-1 text-xs text-foreground-400">
                    <i className="ri-map-pin-line text-[12px]" />
                    {team.location}
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}